import LabelEdit from "../components/labelEdit";

export default LabelEdit;
